import React from 'react';

const WhatIsLeadGenerationAndCostsPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/LJM-Blog-Images-7.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-4xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              What is lead generation<br />
              and what are the costs?
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Lead generation is essential for sustainable growth and is the first step of the sales funnel. This is the process of attracting prospects, nurturing the relationship to increase interest, and finally conversion. Lloyd James can help provide you with the means and methods to generate new leads by supplying high quality and accurate data, adding value to existing data, and delivering customer insight to drive performance and growth <a href="/contact" className="text-pink-600 hover:text-pink-700 underline">click here</a> to speak to a member of our team about lead generation for your business.
                  </p>

                  <p className="text-lg font-semibold text-gray-900 mb-4">
                    <strong>Lead generation strategies</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    There's no standardised approach to lead generation, and in most cases a combination of delivery mechanisms are used to create leads and maximize opportunities. When determining which approach to use, those planning must consider their budget, resources, skill sets, target market, expertise, and more.
                  </p>

                  <p className="text-lg font-semibold text-gray-900 mb-4">
                    <strong>Inbound vs Outbound lead generation</strong>
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The key differences between using inbound and/or outbound strategies are:
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>The control of engagement</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The main difference is the entity controlling the time and place of all activity.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    In an inbound strategy the prospect will choose how they engage. You allow prospects to discover you when the time is right and by the type platform they prefer.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Outbound lead gen consists of you, the one managing the lead generation strategy, deciding when your prospect sees your marketing efforts. Typically, this involves contacting prospects via one or more of the following channels: postal, email, telephone, inserts or social media.
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>The value of marketing assets</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Usually inbound lead gen campaigns have a longer lifetime than outbound campaigns. For example, social media content and online blogs can produce leads long after they were created, providing long-term ROI therefore worth investing in.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Outbound campaigns are typically finite and short in length. Once the campaign ends, most of the assets are not used again, although this can depend on the channel, campaign strategy and consumer touch points.
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>Cost profile of campaigns</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Inbound lead generation campaigns typically have a lower cost, as well as being spread over a longer period. Traffic is earned rather than bought.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The cost and time surrounded by an outbound lead gen campaign will typically be higher and shorter. and this is usually due to the pricing of the channels used (advertising, post or cold calling).
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-3">
                    <strong>The true cost of lead generation</strong>
                  </h5>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The cost per lead metric indicates the success rate of your marketing campaigns. The goal of CPL is to offer your team a tangible amount to help them determine how much budget to spend on acquiring new leads.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    The average costs for lead gen varies greatly depending on which industry your business falls under.
                  </p>

                  <h5 className="text-lg font-semibold text-gray-900 mb-4">
                    Cost per lead benchmarks per industry:
                  </h5>

                  <div className="overflow-x-auto mb-6">
                    <table className="min-w-full border-collapse border border-gray-300">
                      <tbody>
                        <tr className="bg-gray-50">
                          <td className="border border-gray-300 px-4 py-2 font-semibold">Industry</td>
                          <td className="border border-gray-300 px-4 py-2 font-semibold">Cost Per Lead</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">Media and Publishing</td>
                          <td className="border border-gray-300 px-4 py-2">£9.13 – £20.76</td>
                        </tr>
                        <tr className="bg-gray-50">
                          <td className="border border-gray-300 px-4 py-2">Education</td>
                          <td className="border border-gray-300 px-4 py-2">£21.59 – £41.51</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">Healthcare and Medical</td>
                          <td className="border border-gray-300 px-4 py-2">£21.59 – £41.51</td>
                        </tr>
                        <tr className="bg-gray-50">
                          <td className="border border-gray-300 px-4 py-2">Consulting</td>
                          <td className="border border-gray-300 px-4 py-2">£21.59 – £41.51</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">Industrial and Manufacturing</td>
                          <td className="border border-gray-300 px-4 py-2">£21.59 – £41.51</td>
                        </tr>
                        <tr className="bg-gray-50">
                          <td className="border border-gray-300 px-4 py-2">Travel and Tourism</td>
                          <td className="border border-gray-300 px-4 py-2">£21.59 – £41.51</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">Consumer Products</td>
                          <td className="border border-gray-300 px-4 py-2">£21.59 – £41.51</td>
                        </tr>
                        <tr className="bg-gray-50">
                          <td className="border border-gray-300 px-4 py-2">Software</td>
                          <td className="border border-gray-300 px-4 py-2">£42.34 – £83.02</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">Information Tech and Services</td>
                          <td className="border border-gray-300 px-4 py-2">£42.34 – £83.02</td>
                        </tr>
                        <tr className="bg-gray-50">
                          <td className="border border-gray-300 px-4 py-2">Marketing Agencies</td>
                          <td className="border border-gray-300 px-4 py-2">£42.34 – £83.02</td>
                        </tr>
                        <tr>
                          <td className="border border-gray-300 px-4 py-2">Financial Services</td>
                          <td className="border border-gray-300 px-4 py-2">£42.34 – £83.02</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <p className="text-gray-600 text-sm mb-4 italic">
                    The cost per lead varies by industry; with media and publishing reporting the lowest cost per lead at £9.13 – £20.76. Software, information tech and services, marketing agencies, and finally services companies all reporting the highest average cost per lead at £42.34 – £83.02.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Table source: <a href="https://www.hubspot.com/products/crm" className="text-pink-600 hover:text-pink-700 underline">Hubspot</a> USA
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Lead generation is the most effective way to help grow your business. While many services are available for everyone to use, costs for any type of lead generation campaign can accumulate over time. Here at Lloyd James, we endeavour to create a lead generation strategy to grow and develop a business within every budget, using our experience and expertise across both inbound and outbound marketing channels.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    To find out how Lloyd James can help with acquiring these leads for your business <a href="/data-consultancy" className="text-pink-600 hover:text-pink-700 underline">click here.</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhatIsLeadGenerationAndCostsPage;